// frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n/i18n.js';
import './index.css'; // Your existing index.css
import './colors_palette.css'; // Import the color palette
import App from './App';
import AppProvider from "./AppProvider";
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Auth0Provider } from '@auth0/auth0-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Initialize the QueryClient
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // Prevents refetching every time you click away from the browser
      retry: 1,                    // Only retry failed requests once
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));

// Read the variables from the environment, provide a fallback to prevent crashes
const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || "missing-client-id";
const auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN || "missing-auth0-domain";
const auth0ClientId = process.env.REACT_APP_AUTH0_CLIENT_ID || "missing-auth0-client-id";
const auth0Audience = process.env.REACT_APP_AUTH0_AUDIENCE || "http://localhost:5000";

root.render(
  <React.StrictMode>
    {/* Wrap the app with Auth0Provider at the highest level */}
    <Auth0Provider
      domain={auth0Domain}
      clientId={auth0ClientId}
      authorizationParams={{
        redirect_uri: window.location.origin + '/login',
        audience: auth0Audience
      }}
    >
      {/* Always wrap the app. If ID is missing, the button just won't work, but the app won't crash */}
      <GoogleOAuthProvider clientId={googleClientId}>
        {/* Wrap your AppProvider with the QueryClientProvider */}
        <QueryClientProvider client={queryClient}>
          <AppProvider>
            <App />
          </AppProvider>
        </QueryClientProvider>
     </GoogleOAuthProvider>
    </Auth0Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();